module.exports = __webpack_public_path__ + "img/explain-cat.ba66e8f1.png";